import * as Yup from "yup";
import { forceInt } from "Utils";

export const WorkflowValidationSchema = Yup.object().shape({});

export const WorkflowObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    slug: null,
    name: null,
    status: null,
    is_web: null,
    is_print: null,
    is_content: null,
    is_assignment: null,
    priority: null,
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let workflow = Object.assign({}, WorkflowObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        slug: requestData.slug,
        name: requestData.name,
        status: forceInt(requestData.status),
        is_web: forceInt(requestData.is_web),
        is_print: forceInt(requestData.is_print),
        is_content: forceInt(requestData.is_content),
        is_assignment: forceInt(requestData.is_assignment),
        priority: forceInt(requestData.priority),
    });

    return workflow;
}
